:host {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
}

:host(:hover) {
  cursor: pointer;
  fill:var(--grey-20)
}

:host(.active) {
  fill:var(--grey-10)
}